module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-5-sample04-55ae2a6c7911b84bb832877e9f19af87.jpg";